import React from "react";
import { HomepageBody } from "../styles/components/GroupPage";
import CommonAppBar from "../utils/Appbar";

const ActivityPage = () => {

    return (
        <HomepageBody>
            <CommonAppBar section='activity' />
        </HomepageBody>
    );
};

export default ActivityPage;
